import React from 'react';
import { Button, Col, Dropdown, Layout, Row, Spin } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { DownOutlined, UserOutlined } from '@ant-design/icons';

import styles from './prequal.module.scss';
import { AppFooter } from './components/AppFooter/AppFooter';
import { useLoan } from '../stores/store';
import { usePrequal } from '../stores/prequalStore';
import useConfig from '../stores/config';
import { useParams } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';
import { generateUrlParams, getPrequalSource } from '../utils';
import { BOAT_TRADER_SOURCE_ID } from '../constants';
import Logo from '../loan/components/Logo';

type Props = {
  children: React.ReactNode;
  title?: string;
  className?: string;
  showLogin?: boolean;
};

export default observer(function BlankLayout({
  children,
  className,
  title,
  showLogin = true,
}: Props) {
  const loanStore = useLoan();
  const config = useConfig();
  const prequalStore = usePrequal();
  const { prequal } = prequalStore;
  let urlParams: any = {};
  const urlQueryParams = generateUrlParams(null);

  try {
    // this errors if there's no match
    // eslint-disable-next-line react-hooks/rules-of-hooks
    urlParams = useParams();
  } catch (e) {
    // don't need this
  }

  const theme = useTheme(loanStore, config, true);

  if (theme == null) {
    return (
      <Layout className={styles.mainLayout}>
        <Spin size="large" style={{ marginTop: '2rem', display: 'block' }} />
      </Layout>
    );
  }

  const sourceId = getPrequalSource(config, prequal);

  return (
    <Layout className={styles.mainLayout}>
      <Header
        className={classNames(styles.header, {
          [styles.headerBoatTrader]: sourceId === BOAT_TRADER_SOURCE_ID,
        })}
      >
        <Row className={styles.headerRow}>
          <Col>
            <Logo
              imgSrc={theme.logo}
              linkUrl={theme.marketingWebsiteUrl}
              urlQueryParams={urlQueryParams}
            />
          </Col>
        </Row>
      </Header>
      <Content className={classNames(styles.content, className)}>
        <div className="form-container">{children}</div>
      </Content>
      <AppFooter />
    </Layout>
  );
});
